import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  TextField,
  Typography
} from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

const ESTILO_LISTA = {
  maxHeight: 360,
  overflow: 'auto'
};

/* Tags disponíveis para as mensagens do WhatsApp */
const CAMPOS = [
  {
    tag: '{NOMEPAX}',
    descricao: 'Nome completo do pax'
  },
  {
    tag: '{PRIMEIRONOMEPAX}',
    descricao: 'Primeiro nome do pax'
  },
  {
    tag: '{DESCSERVICO}',
    descricao: 'Nome do serviço'
  },
  {
    tag: '{DIASERVICO}',
    descricao: 'Dia do serviço'
  },
  {
    tag: '{MESSERVICO}',
    descricao: 'Mês do serviço'
  },
  {
    tag: '{ANOSERVICO}',
    descricao: 'Ano do serviço'
  },
  {
    tag: '{HORAAPRESENTACAO}',
    descricao: 'Hora da apresentação'
  },
  {
    tag: '{NOMEFANTHOTELITEM}',
    descricao: 'Nome fantasia hotel item'
  },
  {
    tag: '{APTOITEM}',
    descricao: 'Número apartamento item'
  },
  {
    tag: '{TOTALPAXITEM}',
    descricao: 'Total pax item'
  },
  {
    tag: '{HORAINSERVICO}',
    descricao: 'Hora serviço'
  },
  {
    tag: '{DESCVOOITEM}',
    descricao: 'Descrição voo item'
  },
  {
    tag: '{FORNECEDORTRANSPORTE}',
    descricao: 'Nome do fornecedor de transporte'
  },
  {
    tag: '{LOCALIZADOR}',
    descricao: 'Localizador do pax'
  },
  {
    tag: '{NROOS}',
    descricao: 'Número da OS'
  },
  {
    tag: '{HORAVOOOUT}',
    descricao: 'Hora voo OUT'
  },
  {
    tag: '{LOCALDESTINOITEM}',
    descricao: 'Local de destino item'
  },
  {
    tag: '{LOCALORIGEMITEM}',
    descricao: 'Local de origem item'
  },
  {
    tag: '{NOMEGUIA}',
    descricao: 'Nome do guia'
  },
  {
    tag: '{PDVSERVICO}',
    descricao: 'PDV do serviço'
  },
  {
    tag: '{NOMEFANTASIACLIENTE}',
    descricao: 'Nome fantasia cliente OS'
  },
  {
    tag: '{SITEFORNECEDORGUIA}',
    descricao: 'Site fornecedor guia'
  },
  {
    tag: '{OBSITEM}',
    descricao: 'Observação item'
  },
  {
    tag: '{FONEPDVSERVICO}',
    descricao: 'Fone do PDV do serviço'
  },
  {
    tag: '{DATAOUT}',
    descricao: 'Data OUT'
  },
  {
    tag: '{HORARETORNO}',
    descricao: 'Hora retorno'
  },
  {
    tag: '{DESCVOOOUT}',
    descricao: 'Descrição voo out OS'
  },
  {
    tag: '{USUARIOLOGADO}',
    descricao: 'Usuário Logado'
  },
  {
    tag: '{DATAIN}',
    descricao: 'Data IN'
  },
  {
    tag: '{DATAAPRESENTACAO}',
    descricao: 'Data da apresentação'
  }
];

export default function MensagemDicionario({ open, onClose, onInsert }) {
  const [filtro, setFiltro] = useState('');
  const [selecionada, setSelecionada] = useState('');

  const textoFiltro = filtro.toLowerCase();

  const registros = CAMPOS.filter(item => (
    `${item.tag} ${item.descricao}`.toLowerCase().includes(textoFiltro)
  ));

  /* Evento onChange do filtro */
  const onChangeFiltro = (event) => setFiltro(event.target.value);

  /* Insere a tag e fecha o dicionário */
  const inserirTag = (tag) => {
    onInsert(tag);
    onClose();
  };

  /* Clicar para inserir a tag selecionada */
  const inserir = () => {
    if (selecionada) inserirTag(selecionada);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>
        Dicionário de tags - WhatsApp
      </DialogTitle>

      <DialogContent dividers>
        <Typography
          variant="body2"
          color="textSecondary"
        >
          Selecione uma tag para inserir na posição do cursor da mensagem.
        </Typography>

        <TextField
          fullWidth
          margin="normal"
          label="Pesquisar tag ou descrição"
          value={filtro}
          onChange={onChangeFiltro}
        />

        <List
          dense
          style={ESTILO_LISTA}
        >
          {registros.map(item => (
            <ListItem
              button
              key={item.tag}
              selected={selecionada === item.tag}
              onClick={() => setSelecionada(item.tag)}
              onDoubleClick={() => inserirTag(item.tag)}
            >
              <ListItemText
                primary={item.tag}
                secondary={item.descricao}
              />
            </ListItem>
          ))}
        </List>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>
          Cancelar
        </Button>

        <Button
          color="primary"
          variant="contained"
          disabled={!selecionada}
          onClick={inserir}
        >
          Inserir tag
        </Button>
      </DialogActions>
    </Dialog>
  );
};

MensagemDicionario.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onInsert: PropTypes.func
};